import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const PessoaFisicaList = props => <DefaultDataTable data={props} />;
